import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './hobbies.json';

const Hobbies = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            description="Talk about hobbies and how free time has changed. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Hobbies"
            image="/Images/hobbies.webp"
            seoTitle="Free English Lesson Plans: Hobbies"
            seoDescription="Talk about hobbies and how free time has changed. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Hobbies;
